import { Button, Icon, Modal } from '@successmode-ktp/kui';
import styled from 'styled-components';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const UploadedModal = ({ isOpen, onClose }: Props) => {
  return (
    <Modal
      isOpen={isOpen}
      hasBackdrop
      wrapperStyle={{ width: '100%', maxWidth: '335px' }}
    >
      <Modal.Header>
        <TitleWrapper>
          <Icon.CheckFilled fillColor='#246CF6' />
          업로드 완료
        </TitleWrapper>
      </Modal.Header>
      <ModalBody>
        <Contents>
          확인까지 영업일 기준 최대 5일 정도 소요되며 완료 후 환급이 진행됩니다.
        </Contents>
        <Warning>필요에 따라 재업로드 요청을 할 수 있습니다.</Warning>
      </ModalBody>
      <Modal.Footer>
        <Button type='button' size='sm' onClick={onClose}>
          확인
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export default UploadedModal;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  width: 100%;
`;

const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 16px;
  max-width: 320px;
`;

const Contents = styled.p`
  color: var(--KTP-Grayscale-Gray_05, #777);
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.28px;
  word-break: keep-all;
`;

const Warning = styled.small`
  color: var(--KTP-Warning-100, #ed0828);
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.24px;
  word-break: keep-all;
`;
